const sys = require("_js/sys.js");
const logger = require("_js/logger.js");
const ua = require("_js/useragent.js");

let preloader;

const ABX_PRELOADER = 215;
const INRIVAL_PRELOADER = 240;

export function loadAndStartPreloader() {
	const path = `${sys.params.path}preloader`;

	return new Promise((resolve, reject) => {
		try {
			sys.loadScript(`${path}/preloader.min.js?rnd=${Math.random()}`)
				.catch((error) => {
					logger.error(error);

					reject();
				}
				)
				.then(() => {
					const cb = () => {
						resolve();
					};

					const isABXPreloader = Array.isArray(sys.params.game.supp)
						? sys.params.game.supp.some((subSup) => subSup === ABX_PRELOADER)
						: ABX_PRELOADER === sys.params.game.supp;

					preloader = isABXPreloader
						? new window.customPreloader.ABXPreloaderLoader({isDesktop: ua.isDesktop})
						: new window.customPreloader.InrivalPreloaderLoader({isDesktop: ua.isDesktop});

					preloader.start(path, cb);
				});
		} catch (error) {
			logger.error(error);

			reject();
		}
	});
}

export function destroyPreloader() {
	if (preloader) {
		preloader.destroy();
	}
}


// WEBPACK FOOTER //
// ./js/preloader.js